const UserData =
{
  answer: 'heavily'
  // answer: 'yesterday'

}


export default UserData;